module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAK+BAMAAABp2JLEAAAAG1BMVEUAAADh4eHh4eHi4uLg4ODg4ODg4ODg4ODg4OCHeMWpAAAACHRSTlMATE1OhL7y88+MYNkAAABSSURBVFjD7dihDYBAAEPRCoZgAZJbAM8KoBjh5rgE+GOfOYFGkl/xRNMJmryzsCcTsGUGWk7gSgXuVOAZTQHaWGblSBKiqqqqqqqqqj/z+1fQAVirkbDpUECFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/home_splitline@2x.png
// module id = eTGw
// module chunks = 0